import { Icon, mergeStyles } from '@fluentui/react';
import * as React from 'react';
import { FreelanceRequest } from '../../models/requestModels';
import {
  getIsClosed,
  getModalityIconName,
  getRequestTitle,
  getParatureTicketNumber,
} from '../../reduxUpdater/selectors/requestSelector';
import { getCommonClassNames, getCommonStyles } from '../../styles/commonStyles';
import { getRequestHeaderClassNames, getRequestHeaderStyles } from '../../styles/requestHeaderStyles';
import { IThemedProp } from '../../styles/themesUI';

interface IRequestHeaderComponentProps {
  request: FreelanceRequest;
}

type IRequestHeaderProps = IThemedProp & IRequestHeaderComponentProps;

const commonClassNames = getCommonClassNames(getCommonStyles!, {});

export class RequestHeader extends React.PureComponent<IRequestHeaderProps> {
  private requestHeaderClassNames = getRequestHeaderClassNames(getRequestHeaderStyles, { theme: this.props.theme });

  public render(): React.ReactNode {
    if (!this.props.request) {
      return null;
    }

    const iconContainerClassName = mergeStyles(
      this.requestHeaderClassNames.iconContainer,
      !getIsClosed(this.props.request) &&
      this.requestHeaderClassNames.iconBackgroundColorBlue,
      getIsClosed(this.props.request) &&
      this.requestHeaderClassNames.iconBackgroundColorGrey
    );

    return (
      <div className={commonClassNames.flexContainerRow}>
        <div className={iconContainerClassName}>
          <Icon
            iconName={getModalityIconName(this.props.request)}
            styles={this.requestHeaderClassNames.subComponentStyles.requestHeaderIconStyles}
          />
        </div>
        <div className={mergeStyles(commonClassNames.textNormal, this.requestHeaderClassNames.requestTitle)}>
          {getRequestTitle(this.props.request)}
        </div>
        <div className={mergeStyles(commonClassNames.textNormal, this.requestHeaderClassNames.requestParatureTicketNumber)}>
          {`(#${getParatureTicketNumber(this.props.request)})`}
        </div>
      </div>
    );
  }
}
